import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import Operations from '../../../../operations'
import Selectors from '../../../../selectors'
import { IncidentReport } from '../../../../components/reports'
import { get } from 'lodash'
import { GroupsSidebarNavigation } from '../components'
import styled from 'styled-components'

interface GroupIncidentAnalyticsProps {
  data: any[]
  isLoading: boolean
  error?: string
  fetchData: () => void
}

export function GroupIncidentAnalytics(props: GroupIncidentAnalyticsProps) {
  const { isLoading, error, data, fetchData } = props

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <div style={styles.mainContainer}>
      <StyledNavigation>
        <GroupsSidebarNavigation />
      </StyledNavigation>
      <StyledInnerContainer>
        <IncidentReport
          data={data}
          isLoading={isLoading}
          error={error}
          title="Incidents per month"
          backLink={null}
          emptyText="Your group has no Incidents to display."
        />
      </StyledInnerContainer>
    </div>
  )
}

const styles = {
  mainContainer: {
    margin: '0 auto',
    maxWidth: 2000,
    position: 'relative' as const,
    display: 'flex' as const,
    flexDirection: 'row' as const,
    minHeight: 'calc(100vh - 64px)'
  }
}

const StyledInnerContainer = styled.div`
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 24px;
  height: 100%;
  width: 100%;
`

const StyledNavigation = styled.div`
  ${({ theme }) => theme.mediaQueries?.mobileDown} {
    display: none;
  }
`

const STATE_ID = 'group_incidents'
const mapStateToProps = (state: any) => {
  const data = get(state, `data.requests.${STATE_ID}.response`)
  return {
    data: (Selectors.populateWithListData as any)(state, {
      data,
      populate: []
    }),
    isLoading: get(state, `data.requests.${STATE_ID}.isLoading`),
    error: get(state, `data.requests.${STATE_ID}.error`)
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  fetchData: () => {
    dispatch(
      Operations.fetchData({
        url: 'aggregations/incidents',
        id: STATE_ID
      })
    )
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupIncidentAnalytics)
